export const ENTRIES_QUERY_KEY = 'shiftbook-entries' as const;
export const ENTRY_DETAIL_QUERY_KEY = 'shiftbook-entry-detail' as const;
export const ENTRY_ATTACHMENTS_QUERY_KEY = 'shiftbook-entry-attachments' as const;
export const LOOKUP_QUERY_KEY = 'shiftbook-lookups' as const;
export const KEYWORD_LOOKUP_QUERY_KEY = 'shiftbook-keyword-lookups' as const;
export const SUGGESTION_KAP_TAG_LOOKUP_QUERY_KEY = 'shiftbook-suggestion-kap-tag-lookups' as const;
export const TEMPLATE_LOOKUP_QUERY_KEY = 'shiftbook-template-lookups' as const;
export const ADMIN_USERS_QUERY_KEY = 'shiftbook-admin-users' as const;
export const ADMIN_GROUPS_QUERY_KEY = 'shiftbook-admin-groups' as const;
export const ADMIN_FLOCS_QUERY_KEY = 'shiftbook-admin-flocs' as const;
export const ADMIN_KEYWORDS_QUERY_KEY = 'shiftbook-admin-keywords' as const;
export const ADMIN_SUGGESTION_KAP_TAGS_QUERY_KEY = 'shiftbook-admin-suggestion-kap-tags' as const;
export const ADMIN_TEMPLATES_QUERY_KEY = 'shiftbook-admin-templates' as const;
export const NOTIFICATION_INBOX_QUERY_KEY = 'shiftbook-notification-inbox' as const;
export const NOTIFICATION_UNREAD_COUNT_QUERY_KEY = 'shiftbook-notification-unread-count' as const;
export const ENTRY_WORKSPACE_SAVE_MUTATION_KEY = ['shiftbook-entry-workspace-save'] as const;
export const OFFLINE_FIRST = 'offlineFirst' as const;
